/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_TitleInputs */

const cs_youtube_export_title = /** @type {(inputs: Youtube_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export na YouTube`)
};

const en_youtube_export_title = /** @type {(inputs: Youtube_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export to YouTube`)
};

/**
* | output |
* | --- |
* | "Export to YouTube" |
*
* @param {Youtube_Export_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_title = /** @type {((inputs?: Youtube_Export_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_title(inputs)
	return cs_youtube_export_title(inputs)
});